import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getQueryKey as getMilestonesQueryKey } from "@faire/web-api/api/user/milestones/userToken/list/get-hooks";
import { useMutation as useMilestoneMutation } from "@faire/web-api/api/user/milestones/userToken/post-hooks";
import { IGetUserMilestonesResponse } from "@faire/web-api/indigofair/data/IGetUserMilestonesResponse";
import { IUserMilestone } from "@faire/web-api/indigofair/data/IUserMilestone";
import { useQueryClient } from "@tanstack/react-query";
import differenceInDays from "date-fns/differenceInDays";
import { useCallback, useMemo } from "react";
import { getUser } from "../serialized-data/getUser";
import { useMilestonesData } from "./useMilestonesData";
export function useRecordBrandMilestone() {
  var _getUser;
  var userToken = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.token;
  var _useMilestoneMutation = useMilestoneMutation(),
    mutateAsync = _useMilestoneMutation.mutateAsync;
  var queryClient = useQueryClient();
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(milestoneType) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (userToken) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", Promise.resolve());
          case 2:
            return _context.abrupt("return", mutateAsync([userToken, IUserMilestone.build({
              brand_milestone: milestoneType
            })]).then(function (updatedMilestone) {
              queryClient.setQueryData(getMilestonesQueryKey(userToken), function (prev) {
                return IGetUserMilestonesResponse.build({
                  milestones: _objectSpread(_objectSpread({}, prev === null || prev === void 0 ? void 0 : prev.milestones), {}, _defineProperty({}, milestoneType, updatedMilestone))
                });
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [mutateAsync, queryClient, userToken]);
}
export var useBrandMilestone = function useBrandMilestone(milestoneType) {
  var _milestones$milestone;
  var _useMilestonesData = useMilestonesData(),
    milestones = _useMilestonesData.milestones,
    isLoading = _useMilestonesData.isLoading;
  var count = (milestones === null || milestones === void 0 ? void 0 : (_milestones$milestone = milestones[milestoneType]) === null || _milestones$milestone === void 0 ? void 0 : _milestones$milestone.count) || 0;
  var hasOccurred = count > 0;
  var record = useRecordBrandMilestone();
  var setHasOccurred = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!hasOccurred) {
            record(milestoneType);
          }
          return _context2.abrupt("return", Promise.resolve());
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [hasOccurred, record, milestoneType]);
  var incrementCount = useCallback(function () {
    return record(milestoneType);
  }, [record, milestoneType]);
  return useMemo(function () {
    return {
      hasOccurred: hasOccurred,
      count: count,
      setHasOccurred: setHasOccurred,
      incrementCount: incrementCount,
      isLoading: isLoading
    };
  }, [count, hasOccurred, incrementCount, setHasOccurred, isLoading]);
};
export function useRecordMilestoneOnce() {
  var _useMilestonesData2 = useMilestonesData(),
    milestones = _useMilestonesData2.milestones;
  var record = useRecordBrandMilestone();
  return useCallback(function (milestoneType) {
    var _milestones$milestone2;
    if (!(milestones !== null && milestones !== void 0 && (_milestones$milestone2 = milestones[milestoneType]) !== null && _milestones$milestone2 !== void 0 && _milestones$milestone2.count)) {
      return record(milestoneType);
    }
    return Promise.resolve();
  }, [milestones, record]);
}
export function useRecordBrandMilestoneByDay() {
  var _useMilestonesData3 = useMilestonesData(),
    milestones = _useMilestonesData3.milestones;
  var record = useRecordBrandMilestone();
  return useCallback(function (milestoneType) {
    var _milestone$updated_at;
    var milestone = milestones === null || milestones === void 0 ? void 0 : milestones[milestoneType];
    if (!(milestone !== null && milestone !== void 0 && milestone.count)) {
      return record(milestoneType);
    }
    var updatedAt = (_milestone$updated_at = milestone === null || milestone === void 0 ? void 0 : milestone.updated_at) !== null && _milestone$updated_at !== void 0 ? _milestone$updated_at : 0;
    var now = Date.now();
    if (differenceInDays(now, updatedAt) >= 1) {
      return record(milestoneType);
    }
    return Promise.resolve();
  }, [milestones, record]);
}
export function useIsBrandMilestoneOverWeekOld(milestoneType) {
  return useIsBrandMilestoneOverDaysOld(milestoneType, 7);
}
export function useIsBrandMilestoneOverDaysOld(milestoneType, days) {
  var _useMilestonesData4, _useMilestonesData4$m, _milestone$updated_at2;
  var milestone = (_useMilestonesData4 = useMilestonesData()) === null || _useMilestonesData4 === void 0 ? void 0 : (_useMilestonesData4$m = _useMilestonesData4.milestones) === null || _useMilestonesData4$m === void 0 ? void 0 : _useMilestonesData4$m[milestoneType];
  if (!(milestone !== null && milestone !== void 0 && milestone.count)) {
    return false;
  }
  var updatedAt = (_milestone$updated_at2 = milestone === null || milestone === void 0 ? void 0 : milestone.updated_at) !== null && _milestone$updated_at2 !== void 0 ? _milestone$updated_at2 : 0;
  var now = Date.now();
  if (differenceInDays(now, updatedAt) >= days) {
    return true;
  }
  return false;
}